import { fetchAxios } from "../API/fetchAxios";

export const getIndividualAccountStatusRequest = () =>
  fetchAxios({ verb: "GET", context: "individualAccountStatus" });

export const createIndividualAccountRequest = (body) =>
  fetchAxios({ verb: "POST", context: "individualAccountCreate", body });

export const createLivenessSessionRequest = (body) =>
  fetchAxios({ verb: "POST", context: "individualAccountLiveness", body });

export const getLivenessSessionStatusRequest = (sessionId) =>
  fetchAxios({ verb: "GET", context: "individualAccountLiveness", id: sessionId });

export const submitIndividualAccountKycRequest = (files) => {
  const formData = new FormData();

  if (files.addressProof) {
    formData.append("address_proof", files.addressProof);
  }
  if (files.socialContract) {
    formData.append("social_contract", files.socialContract);
  }
  if (files.sourceOfFunds) {
    formData.append("source_of_funds", files.sourceOfFunds);
  }

  return fetchAxios({
    verb: "POST",
    context: "individualAccountKyc",
    body: formData,
    additionalHeaders: { "Content-Type": "multipart/form-data" },
  });
};
